import { defineStore } from "pinia";

export const useSignInStore = defineStore("signIn", {
  state: () => ({ email: "" })
});
